import _ from 'lodash'
const install = function (Vue) {
    Vue.prototype._ = _
    //数字转金额
    //例) input=12345    output="12345.00"
    //例) input=12345.89 output="12345.89"
    Vue.prototype.number_to_currency = function (input) {
        return input.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&');
    }
    //转化成float
    Vue.prototype.toFloat = function (val) {
        if (!val) return 0.00;
        if (val == "") return 0.00;
        if (isNaN(val)) return 0.00;
        return parseFloat(val);
    }
    //转化成float
    Vue.prototype.fix = function (val) {
        if (!val) return Number(0.00);
        if (val == "") return Number(0.00);
        if (isNaN(val)) return Number(0.00);
        return Number(Number(val).toFixed(2));
    };
    // 格式化后端返回的date时间
    // 例子) val = /Date(1564397176420)/ output="2019-9-28 18:45:30"
    Vue.prototype.FormatToDate = function (val) {
        if (val != null) {
            var date = new Date(parseInt(val.replace("/Date(", "").replace(")/", ""), 10));
            //月份为0-11，所以+1，月份小于10时补个0
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            return date.getFullYear() + "-" + month + "-" + currentDate + ' ' + hours + ':' + minute + ':' + seconds
        }
        return "";
    }
    // 例子) val = /Date(1564397176420)/ output="2019-9-28" 专为打印设置
    Vue.prototype.FormatToDatePrint = function (val) {
        if (val != null) {
            var date = new Date(parseInt(val.replace("/Date(", "").replace(")/", ""), 10));
            //月份为0-11，所以+1，月份小于10时补个0
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            return date.getFullYear() + "-" + month + "-" + currentDate
        }
        return "";
    }
    // 格式化时间 {封装}
    //例) time = Fri Jul 26 2019 14:50:55 GMT+0800 (中国标准时间) output="2019-7-26"
    Vue.prototype.timeStamp2String = function (time) {
        var datetime = new Date();
        datetime.setTime(time);
        var year = datetime.getFullYear();
        var month =
            datetime.getMonth() + 1 < 10 ?
                "0" + (datetime.getMonth() + 1) :
                datetime.getMonth() + 1;
        var date =
            datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
        return year + "-" + month + "-" + date;
    }
    // 格式化打印时间时间
    //例) time = Fri Jul 26 2019 14:50:55 GMT+0800 (中国标准时间) output="2019-7-26 14:29:30"
    Vue.prototype.timeStamp2Today = function (time) {
        var datetime = new Date();
        datetime.setTime(time);
        var year = datetime.getFullYear();
        var month =
            datetime.getMonth() + 1 < 10 ?
                "0" + (datetime.getMonth() + 1) :
                datetime.getMonth() + 1;
        var date =
            datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
        var hour =
            datetime.getHours() < 10 ?
                "0" + datetime.getHours() :
                datetime.getHours();
        var minute =
            datetime.getMinutes() < 10 ?
                "0" + datetime.getMinutes() :
                datetime.getMinutes();
        var second =
            datetime.getSeconds() < 10 ?
                "0" + datetime.getSeconds() :
                datetime.getSeconds();
        return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
    }
    // 取最近n天的日期
    Vue.prototype.getdate = function (addDayCount) {
        //获取AddDayCount天后的日期
        var now = new Date();
        now.setDate(now.getDate() + addDayCount);
        var y = now.getFullYear();
        var m = now.getMonth() + 1;
        var d = now.getDate();
        var m = m < 10 ? "0" + m : m;
        var d = d < 10 ? "0" + d : d;
        return y + "-" + m + "-" + d;
    }

    // 排序按英文排序 按商品编码排序
    Vue.prototype.sortString = function (arr) {
        arr.sort(function (a, b) {
            if (a.partItemName < b.partItemName) {
                return -1;
            }
            if (a.partItemName > b.partItemName) {
                return 1;
            }
            return 0;
        });
        return arr;
    }
    Vue.prototype.directionFn = function (direction) {
        //键盘上下键切换表格input
        direction.on('keyup', function (e) {
            if (e.keyCode === 38) {
                direction.previousLine()
                localStorage.setItem("clickNum", 1)
            }
            if (e.keyCode === 40) {
                direction.nextLine()
                localStorage.setItem("clickNum", 1)
            }
            if (e.keyCode === 13 || e.keyCode === 108) {
                direction.next()
                localStorage.setItem("clickNum", 1)
            }
            if (e.keyCode === 37) {
                if (e.target.selectionStart == 0 && (e.target.selectionStart == e.target.selectionEnd)) {

                    if (localStorage.getItem("clickNum") != 2) {
                        localStorage.setItem("clickNum", 2)
                    } else if (localStorage.getItem("clickNum") == 2) {
                        direction.previous()
                        localStorage.setItem("clickNum", 1)
                    }
                } else {
                    localStorage.setItem("clickNum", 1)
                }
            }
            if (e.keyCode === 39) {
                if (e.target.selectionStart == e.target.value.length && (e.target.selectionStart == e.target.selectionEnd)) {

                    if (localStorage.getItem("clickNum") != 3) {
                        localStorage.setItem("clickNum", 3)
                    } else if (localStorage.getItem("clickNum") == 3) {
                        direction.next()
                        localStorage.setItem("clickNum", 1)
                    }
                } else {
                    localStorage.setItem("clickNum", 1)
                }
            }
            if ((e.keyCode < 37 || e.keyCode > 40) && (e.target.selectionStart == e.target.value.length)) {
                localStorage.setItem("clickNum", 3)
            }
        })
    }
    // 键盘enter执行tab事件 [暂时不需要]
    Vue.prototype.enterSelect = function (obj) {
        obj.keydown(function () {
            if (13 == event.keyCode) {
                for (var i = 0; i < obj.length; i++) {
                    if ($(obj[i]).is($(this))) { //判断两个jQuery对象是否相等用is
                        if (i == obj.length - 1) {
                            $(obj[0]).select();
                        } else {
                            $(obj[i + 1]).select();
                        }
                    }
                }
            }
        });
    }
    Vue.prototype.daysBetween = function (sDate1, sDate2) {
        //Date.parse() 解析一个日期时间字符串，并返回1970/1/1 午夜距离该日期时间的毫秒数
        var time1 = Date.parse(new Date(sDate1));
        var time2 = Date.parse(new Date(sDate2));
        var nDays = Math.abs(parseInt((time2 - time1) / 1000 / 3600 / 24));
        return nDays;
    }
    Vue.prototype.handleInputFloat = function (price) {
        // 控制输入的价格加上小数点后面的2位  总位数的长度
        if (price == "") {
            return "";
        }
        price = price.slice(0, 10);

        price = price
            .replace(/[^\d.]/g, "")
            .replace(/\.{2,}/g, ".")
            .replace(".", "$#$")
            .replace(/\./g, "")
            .replace("$#$", ".")
            .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
        return price;
    }
    Vue.prototype.newGuid = function () {
        var S4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
    }
    Vue.prototype.judgeDivisor = function (m, n) {
        // 两个数  相除-除不尽
        var num = {};
        var i = 0;
        var x = parseInt(m / n);
        m = m % n;
        var result = "";
        while (m != 0 && !(m in num)) {
            num[m] = i++;
            result += parseInt(m * 10 / n);
            m = m * 10 % n;
        }
        if (m) {
            var index = num[m];
            return x + ". " + result.substring(0, index) + "( " + result.substring(index) + ") ";
        }
        return x + ". " + result;
    }
    //存储cookie
    Vue.prototype.setCookie = function (name, value, days) {
        var _this = this;
        var Days = days;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        if (days == 0) {
            document.cookie = name + "=" + escape(value)
        } else {
            document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
        }
    }
    //得到cookie
    Vue.prototype.getCookie = function (name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return unescape(arr[2]);
        else
            return null;
    }
    //获取url参数
    Vue.prototype.getQueryString = function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        } else {
            var strHash = window.location.hash;

            if (strHash &&
                strHash.length > 0 &&
                strHash.indexOf("?") > -1) {
                r = strHash.substr(strHash.indexOf("?") + 1).match(reg);
            }
            if (r != null) {
                return unescape(r[2]);
            }
        }
        return null;
    }
    //更新url参数
    Vue.prototype.updateQueryStringParameter = function (uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            return uri + separator + key + "=" + value;
        }
    }
}
export default install